// extracted by mini-css-extract-plugin
module.exports = {"container":"SafarMarketBanner_container__8dilZ","safarmarket-logo":"SafarMarketBanner_safarmarket-logo__lpour"};